// Ported from EnterpriseTemplates react-project-template (Release 1.3.1), PMS slice 4b.
// Catalog screen ORG_ENTITY (database-template seed/026).
import React from 'react';
import { OrganisationMasterScreen } from '../OrganisationMasterScreen';
import { entityDefinition } from '../organisationDefinitions';

const EntityMasterScreen: React.FC<{ moduleIcon?: string; tabId?: string; moduleName?: string; allowedActions?: string[] }> = (props) => (
  <OrganisationMasterScreen definition={entityDefinition} {...props} />
);

export default EntityMasterScreen;
